import type { DisplayText } from "@/components/platform/common/displayText";
import { resolveDisplayText } from "@/components/platform/common/displayText";
import Key from "@/app/types/common/key";
import { translate } from "@/plugins/i18n";

export interface LabelledConfiguration {
  label: DisplayText;

  /**
   * If not defined, a tooltip will attempt to be resolved by adding `_hint` to the label key.
   */
  tooltip?: DisplayText;

  /**
   * If not defined, it will use a label translation key if one is available.
   */
  dataQa?: string;
}

export type LabellingControlProps = {
  label: string;
  tooltip?: string;
  dataQa?: string;
};

export function resolveLabellingConfigurationToControlProps(
  labelled: LabelledConfiguration
): LabellingControlProps {
  let keyOrLiteral;

  if (labelled.label instanceof Function) {
    keyOrLiteral = labelled.label();
  } else {
    keyOrLiteral = labelled.label;
  }

  if (keyOrLiteral instanceof Key) {
    return {
      label: translate(keyOrLiteral),
      tooltip: labelled.tooltip
        ? resolveDisplayText(labelled.tooltip)
        : translate(Key.fromString(`${keyOrLiteral}_hint`)), // missing resolves to ""
      dataQa: labelled.dataQa ?? keyOrLiteral.toString(),
    };
  } else {
    return {
      label: keyOrLiteral.toString(),
      tooltip: labelled.tooltip
        ? resolveDisplayText(labelled.tooltip)
        : undefined,
      dataQa: labelled.dataQa,
    };
  }
}
